import { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const SlotMachineText = ({ text }: { text: string }) => {
  const [displayedText, setDisplayedText] = useState(text);
  const [animating, setAnimating] = useState(false);

  useEffect(() => {
    if (text !== displayedText) {
      setAnimating(true);
      setTimeout(() => {
        setDisplayedText(text);
        setAnimating(false);
      }, 450); // Adjust timing to control animation speed
    }
  }, [text]);

  const transitionSettings = {
    type: 'spring',
    stiffness: 175,
    damping: 15,
    mass: 1,
  };

  return (
    <div
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        overflow: 'visible',
        position: 'relative',
        marginLeft: '12px',
        WebkitTextFillColor: 'white',
      }}
    >
      <AnimatePresence mode="wait">
        {animating ? (
          <motion.div
            key="slot-animation"
            initial={{ y: 0, opacity: 1 }}
            animate={{ y: '50%', opacity: 0 }}
            transition={transitionSettings}
            style={{ position: 'absolute', width: '100%', color: 'white' }}
          >
            {` ${displayedText}`}
          </motion.div>
        ) : (
          <motion.div
            key={text}
            initial={{ y: '-50%', opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={transitionSettings}
            style={{ position: 'absolute', width: '100%', color: 'white' }}
          >
            {` ${text}`}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default SlotMachineText;
